import apiService from '../../../services/apiService';
import axios from 'axios';

const TIFFIN_API = '/ykrestapi/Tiffin';
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const tiffinAdminService = {
  // Get all menus
  getMenus: async (orgId = 3) => {
    const response = await apiService.get(`${TIFFIN_API}/admin/menus?orgId=${orgId}`);
    return response.data;
  },

  // Create or update menu
  upsertMenu: async (menuData) => {
    const response = await apiService.post(`${TIFFIN_API}/admin/menu`, menuData);
    return response.data;
  },

  // Get items for a menu
  getMenuItems: async (menuId) => {
    const response = await apiService.get(`${TIFFIN_API}/admin/menu/${menuId}/items`);
    return response.data;
  },

  // Create or update menu item
  upsertMenuItem: async (itemData) => {
    const response = await apiService.post(`${TIFFIN_API}/admin/menu-item`, itemData);
    return response.data;
  },

  // Delete menu item
  deleteMenuItem: async (menuItemId) => {
    const response = await apiService.delete(`${TIFFIN_API}/admin/menu-item/${menuItemId}`);
    return response.data;
  },

  // Upload image for menu item (keep raw axios for multipart)
  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post(`${API_BASE_URL}${TIFFIN_API}/admin/upload-image`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
};

export default tiffinAdminService;
